document.addEventListener("DOMContentLoaded", function () {
  const faqQuestions = document.querySelectorAll(".faq_q");

  faqQuestions.forEach(function (question) {
    question.addEventListener("click", function () {
      faqQuestions.forEach(function (otherQuestion) {
        if (question !== otherQuestion) {
          const otherParentItem = otherQuestion.closest(".item");
          otherParentItem.classList.remove("active");
          const otherFaqAnswer = otherParentItem.querySelector(".faq_a");
          otherFaqAnswer.classList.remove("active");
          otherQuestion.classList.remove("active");
        }
      });

      const parentItem = question.closest(".item");
      parentItem.classList.toggle("active");
      const faqAnswer = parentItem.querySelector(".faq_a");
      faqAnswer.classList.toggle("active");
      this.classList.toggle("active");
    });
  });
});
